import { render, staticRenderFns } from "./Navbar.vue?vue&type=template&id=b70a9a4a&"
import script from "./Navbar.vue?vue&type=script&lang=ts&"
export * from "./Navbar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BrandIdentity: require('/var/www/fbd-kte/assets/components/gui/brand/BrandIdentity.vue').default})
